import { FC, useState } from "react";

import { EyeIcon, EyeOffIcon } from "../../assets/img/icons";

import "./style.css";

interface Props {
    id?: string;
    className?: string;
    label?: string;
    type?: string;
    placeholder?: string;
    value: string;
    setValue?: (value: string) => void;
    error?: string;
    disabled?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const TextInput: FC<Props> = ({
    id,
    className,
    label,
    type,
    placeholder,
    value,
    setValue,
    error,
    disabled,
    onKeyDown,
}) => {
    const isPassword = type === "password";
    const [showPassword, setShowPassword] = useState(false);
    const inputType = isPassword
        ? showPassword
            ? "text"
            : "password"
        : type || "text";

    return (
        <div className="textinput_form">
            {label && <label className="textinput_form_label">{label}</label>}
            <div
                className={`textinput_form_control${
                    isPassword ? " textinput_form_control--with-toggle" : ""
                }`}
            >
                <input
                    id={id}
                    type={inputType}
                    value={value}
                    onChange={(e) => setValue?.(e.target.value)}
                    placeholder={placeholder || ""}
                    className={`${className ?? ""} textinput_form_input`}
                    disabled={disabled}
                    onKeyDown={onKeyDown}
                />
                {isPassword && (
                    <button
                        type="button"
                        className="textinput_password_toggle"
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label={
                            showPassword
                                ? "Masquer le mot de passe"
                                : "Afficher le mot de passe"
                        }
                        aria-pressed={showPassword}
                    >
                        {showPassword ? (
                            <EyeOffIcon width={20} height={20} />
                        ) : (
                            <EyeIcon width={20} height={20} />
                        )}
                    </button>
                )}
            </div>
            {error && <p className="textinput_error_text">{error}</p>}
        </div>
    );
};

export default TextInput;
